<template>
  <Select
    @change="onChange"
    v-model="value"
    placeholder="Сонгоно уу"
    class="wd-100p"
    size="small"
  >
    <Option label="Бүгд" :value="null"></Option>
    <Option label="Тийм" :value="1"></Option>
    <Option label="Үгүй" :value="0"></Option>
  </Select>
</template>
<script>
import "element-ui/lib/theme-chalk/index.css";
import { Select, Option } from "element-ui";

export default {
  components: {
    Select,
    Option
  },
  data() {
    return {
      value: null
    };
  },
  methods: {
    onChange(e) {
      this.$emit("input", e);
    }
  }
};
</script>
